import React from "react";
import { useNavigate } from "react-router-dom";
import { B2BLayout } from "../../components/b2b/B2BLayout";
import { useB2BSettings } from "../../lib/b2b";
import { Check, X, ArrowRight, Sparkles } from "lucide-react";

export default function B2BPlans() {
  const nav = useNavigate();
  const s = useB2BSettings();
  const plans = s?.plans || [];
  const choose = (id) => nav("/contatti", { state: { plan: id } });

  return (
    <B2BLayout>
      <section className="mx-auto max-w-6xl px-5 py-12">
        <h1 className="font-display text-3xl font-extrabold tracking-tight text-[#0B1F3A] sm:text-4xl">I piani di abbonamento</h1>
        <p className="mt-3 max-w-2xl text-base text-[#0B1F3A]/70">Tre livelli di controllo programmato. Il prezzo viene definito dalla commerciale dopo aver verificato immobili, dotazioni, zona e copertura.</p>

        <div className="mt-8 grid gap-5 lg:grid-cols-3">
          {plans.map((p, idx) => (
            <div key={p.id} data-testid={`plan-card-${p.id}`} className={`relative flex flex-col rounded-3xl border bg-white p-6 shadow-sm ${idx === 1 ? "border-[#0E7C7B] ring-2 ring-[#0E7C7B]/30" : "border-[#0B1F3A]/10"}`}>
              {idx === 1 && <span className="absolute -top-3 left-6 flex items-center gap-1 rounded-full bg-[#0E7C7B] px-3 py-1 text-xs font-bold text-white"><Sparkles className="h-3 w-3" />Più scelto</span>}
              <h2 className="font-display text-2xl font-extrabold text-[#0B1F3A]">{p.name}</h2>
              <p className="mt-1 min-h-[48px] text-sm text-[#0B1F3A]/60">{p.tagline}</p>
              <ul className="mt-5 flex-1 space-y-2.5">
                {p.features.map((ft, i) => <li key={i} className="flex gap-2 text-sm text-[#0B1F3A]/85"><Check className="h-4 w-4 shrink-0 text-[#0E7C7B]" />{ft}</li>)}
                {p.excluded.map((ex, i) => <li key={`e${i}`} className="flex gap-2 text-sm text-[#0B1F3A]/45"><X className="h-4 w-4 shrink-0 text-rose-400" />{ex}</li>)}
              </ul>
              <button data-testid={`plan-request-${p.id}`} onClick={() => choose(p.id)} className={`mt-6 flex items-center justify-center gap-2 rounded-full py-3.5 font-bold transition active:scale-[0.98] ${idx === 1 ? "bg-[#F97316] text-white shadow-lg shadow-[#F97316]/25 hover:brightness-110" : "border border-[#0B1F3A]/15 text-[#0B1F3A] hover:border-[#0E7C7B]"}`}>Richiedi questo piano <ArrowRight className="h-4 w-4" /></button>
            </div>
          ))}
        </div>

        <div className="mt-8 space-y-3">
          <div className="rounded-2xl border border-[#0B1F3A]/10 bg-white p-5 text-sm text-[#0B1F3A]/75">{s?.plans_note}</div>
          <div className="rounded-2xl bg-[#0E7C7B]/5 p-5 text-sm text-[#0B1F3A]/75">{s?.billing_note}</div>
        </div>

        <div className="mt-8 rounded-3xl bg-[#0B1F3A] p-6 text-center text-white sm:p-8">
          <p className="font-display text-lg font-bold">Non sai quale piano fa per te?</p>
          <p className="mx-auto mt-1 max-w-md text-sm text-white/70">Rispondi a poche domande sui tuoi immobili e ti suggeriamo il piano più adatto.</p>
          <button data-testid="plans-to-selector" onClick={() => nav("/scegli-piano")} className="mt-4 rounded-full bg-[#F97316] px-6 py-3 font-bold text-white">Aiutami a scegliere</button>
        </div>
      </section>
    </B2BLayout>
  );
}
